import { render, staticRenderFns } from "./multipleControl.vue?vue&type=template&id=28f88c4f&scoped=true"
import script from "./multipleControl.vue?vue&type=script&lang=js"
export * from "./multipleControl.vue?vue&type=script&lang=js"
import style0 from "./multipleControl.vue?vue&type=style&index=0&id=28f88c4f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f88c4f",
  null
  
)

export default component.exports